import { styled, Colors, Theme, flexCenter } from '@unfold/theme';

export const PickerContainer = styled.div`
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 75px;
  height: 75px;
  border-radius: 100%;
  ${flexCenter}
  background-color: ${({ theme }): string =>
  theme.name === Theme.LIGHT ? Colors.G500 : Colors.G200};

  &:hover {
    .avatar-icon {
      display: flex;
    }
  }
  `;

export const Label = styled.label`
  border-radius: 100%;
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Input = styled.input`
  height: 0;
  overflow: hidden;
  width: 0;
`;
